import Heading from "../../shared/ui/Typography/Heading";
import Text from "../../shared/ui/Typography/Text";

import { JoinRequestWithClientForm } from "../../features/companyJoinRequestWithClient";

// CompanyJoinRequestWithClientScreen — route landing for
// /companies/join-request/new-client. Mounts under MainLayout. Thin
// composition wrapper around the feature widget. No selectors, no
// dispatch, no state, no orchestration — all owned by the widget.

function CompanyJoinRequestWithClientScreen() {
  return (
    <section
      className="feature-company-join-request-client"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <header className="feature-company-join-request-client__header">
          <Heading level={1} variant="page">
            Запит на приєднання з клієнтом
          </Heading>
          <Text as="p" size="sm" tone="secondary">
            Знайдіть компанію та за бажанням створіть першого клієнта
            одночасно із надсиланням запиту.
          </Text>
        </header>

        <JoinRequestWithClientForm />
      </div>
    </section>
  );
}

export default CompanyJoinRequestWithClientScreen;
